export default __webpack_public_path__ + "static/media/43.1288e1b2.jpeg";